import { IEnumerable } from "./ModelHelpers";

export const NOTIFICATION_RULE_LEVEL = 1;
export const NOTIFICATION_RULE_TRIP = 2;
export const NOTIFICATION_RULE_READING = 3;

export const NOTIFICATION_RULES = [
  NOTIFICATION_RULE_LEVEL,
  NOTIFICATION_RULE_TRIP,
  NOTIFICATION_RULE_READING,
] as const;

export type notificationRule = typeof NOTIFICATION_RULES[number];

type NotificationRuleModel = {
  notificationRule: notificationRule;
  id: IEnumerable;
};

export default NotificationRuleModel;

export function getNotificationRuleFromEnum(rule: notificationRule): string {
  switch (rule) {
    case NOTIFICATION_RULE_LEVEL:
      return "Nível";

    case NOTIFICATION_RULE_TRIP:
      return "Viagem";

    case NOTIFICATION_RULE_READING:
      return "Sem leitura (>6h)";
    default:
      // eslint-disable-next-line no-console
      console.error("getNotificationRuleFromEnum → rule not valid! Returning empty!");
      return "";
  }
}
